  // export const IPUrl ="http://192.168.100.110:8100/";
 //export const IPUrl ="http://192.168.100.55:7003/";
// export const IPUrl ="https://portalcity.myamol.ir/";
let hostName = window.location.host;
hostName = hostName.split('.');

let IPUrl;

      {hostName.length === 2 ?
        IPUrl = !process.env.NODE_ENV || process.env.NODE_ENV === 'development' ? "http://192.168.100.55:7003/" : `https://portalcity.${hostName[0]}.${hostName[1]}/` 
        :
        IPUrl = !process.env.NODE_ENV || process.env.NODE_ENV === 'development' ? "http://192.168.100.55:7003/" : `https://portalcity.${hostName[1]}.${hostName[2]}/` 
      }  
export {IPUrl}

 